<template>
  <v-app dark>
    <v-toolbar app fixed>
      <v-toolbar-title class="headline">
        <span class="font-weight-light">
          <span class="red--text">r</span>
          <span class="blue--text">f</span>Weather
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn flat href="https://github.com/vuetifyjs/vuetify/releases/latest" target="_blank">
        <span class="mr-2">Latest Release</span>
      </v-btn>-->
    </v-toolbar>

    <v-content>
      <DeviceStatus/>
      <br>
      <!-- <Counter/> -->
      <!-- <WeatherCards/> -->
      <!-- <HelloWorld/> -->
      <WeatherCards/>
      <WeatherData/>
    </v-content>
  </v-app>
</template>

<script>
// import HelloWorld from "./components/HelloWorld";
// import WeatherData from "./components/WeatherData";
// import DeviceStatus from "./components/DeviceStatus";
// import WeatherCards from "./components/WeatherCards";

export default {
  name: "App",
  components: {
    // HelloWorld,
    // WeatherData,
    // DeviceStatus,
    // WeatherCards
  },
  data() {
    return {
      //
    };
  }
};
</script>
